<template>
  <div class="m-grid__item m-grid__item--order-tablet-and-mobile-2 m-login__aside">
    <div class="m-stack m-stack--hor m-stack--desktop">
      <div class="m-stack__item m-stack__item--fluid">
        <div class="m-login__wrapper">
          <div class="m-login__logo">
            <img src="/media/img/logo_superaccess.png">
          </div>
          <s-alert v-if="alert" :body="text_body" :alertType="alert_class"></s-alert>
          <div class="m-login__signin">
            <div class="m-login__head">
              <h3 class="m-login__title">
                {{ 'forgot_password_text' | capitalize }}
              </h3>
              <div class="m-login__desc">
                {{ 'enter_your_email' | capitalize }}
              </div>
            </div>
            <form class="m-login__form m-form" action="">
              <div class="form-group m-form__group has-danger">
                <input v-validate="'required|email'" v-model="email" :class="{'input': true, 'danger': errors.has('email') }" class="form-control m-input" type="text" id="email-login" :placeholder="'email' | capitalize" name="email" autocomplete="off">
                <span v-show="errors.has('email')" class="form-control-feedback">{{ errors.first('email') }}</span>
              </div>
              <div class="m-login__form-action">
                <button id="btn-send" @click.prevent="sendIt()" class="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air">
                  {{ 'send' | capitalize }}
                </button>
                <router-link :to="{ name: 'login' }" class="btn btn-outline-focus m-btn m-btn--pill m-btn--custom m-btn--air">
                  {{ 'cancel' | capitalize }}
                </router-link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SAlert from '@/components/layout/alert/Alert.vue'
export default {
  components: { SAlert },
  data () {
    return {
      email: '',
      alert: false,
      text_body: '',
      alert_class: ''
    }
  },
  methods: {
    sendIt () {
      this.$validator.validateAll()
        .then((result) => {
          if (result) {
            this.$spinner.show()
            this.$store.dispatch('postResetPassword', this.email)
              .then((res) => {
                if (res.data.status === 200) {
                  this.$router.push({
                    name: 'login',
                    params: { code: 200, message: 'forgot_password_message' }
                  })
                } else if (res.data.status === 400) {
                  this.alert = true
                  this.text_body = this.$options.filters.capitalize('invalid_email')
                  this.alert_class = 'alert-danger'
                  setTimeout(() => {
                    this.alert = false
                  }, 20000)
                }
                this.$spinner.remove()
              })
              .catch((err) => {
                this.$spinner.remove()
                console.log(err)
              })
          }
        }, error => {
          console.log(error)
        })
    }
  }
}
</script>

<style scoped>
  img {
    width: 200px;
  }

  .m-login__wrapper {
    padding-top: 0px !important;
  }

  #btn-send {
    background-color: #001644;
    border-color: #001644;
  }

</style>




// WEBPACK FOOTER //
// GetPassword.vue